const CheckPoweredBy = () => {
  let pb = false;
  if (window.location.host.includes("freede-agency")) {
    pb = true;
  }
  if (window.location.host.includes("testagency")) {
    pb = true;
  }
  if (window.location.host.includes("testagencyb")) {
    pb = true;
  }
  if (window.location.host.includes("knute")) {
    pb = true;
  }
  return pb;
};

const PoweredBy = CheckPoweredBy();
export default PoweredBy;
